<label class="global-form-field mb-2" *ngIf="label">{{ label | translate}} <span class="text-danger fw-bold" *ngIf="required">*</span></label>
<div class="d-flex align-items-center">
  <div *ngFor="let option of options" class="form-check global-form-field me-3">
    <input type="radio"
           [value]="option.value"
           [id]="name + '-' + option.value"
           [disabled]="disabled"
           [name]="name" 
           (change)="onChange(option.value)" 
           [(ngModel)] = "value"
           [required]="required"
           #inputModel="ngModel"
           [checked]="option.value === status"
           class="form-check-input border" />
    <label [for]="name + '-' + option.value" class="form-check-label">{{ option.label }}</label>
  </div>
  <label class="form-check-label">{{status}}</label>
</div>
<div *ngIf="inputModel?.invalid && inputModel?.touched" class="error">
    <span>This field is required</span>
</div>